import './Story.css';
import storyList from '../assets/constants/stories/storyList'
import React from "react";


function Blog() {
    return (
        <div className="">
            <div className="welcomeDivText">
                    <p className="four"> welcome to </p>
                    <p className="eight"> one of fourteen </p>
            </div>
            <div className="">
                {storyList.map((story, index) => (
                    <div className="">
                        {story.title}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Blog;